import Immutable from 'seamless-immutable';
import {
  TEMPLATE_CATEGORY_DELETE_API_FULFILLED,
  TEMPLATE_CATEGORY_DELETE_API_REJECTED,
  TEMPLATE_CATEGORY_DELETE_START,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_FULFILLED,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_REJECTED,
  TEMPLATE_CATEGORY_FETCH_TEMPLATES_START,
  TEMPLATE_CATEGORY_UPDATE_API_FULFILLED,
  TEMPLATE_CATEGORY_UPDATE_API_REJECTED,
  TEMPLATE_CATEGORY_UPDATE_START
} from './templates-actions';

const UPDATE = 'updateTemplateCategories';
const DELETE = 'deleteTemplateCategories';
const FETCH_TEMPLATES = 'fetchTemplateCategories';

export default (
  state = Immutable.from({
    [UPDATE]: {},
    [DELETE]: {},
    [FETCH_TEMPLATES]: {}
  }),
  action
) => {
  switch (action.type) {
    case TEMPLATE_CATEGORY_UPDATE_START:
      return state.setIn([UPDATE, action.meta.id], true);
    case TEMPLATE_CATEGORY_UPDATE_API_FULFILLED:
    case TEMPLATE_CATEGORY_UPDATE_API_REJECTED:
      return state.set(UPDATE, state[UPDATE].without(action.meta.id));
    case TEMPLATE_CATEGORY_DELETE_START:
      return state.setIn([DELETE, action.meta.id], true);
    case TEMPLATE_CATEGORY_DELETE_API_FULFILLED:
    case TEMPLATE_CATEGORY_DELETE_API_REJECTED:
      return state.set(DELETE, state[DELETE].without(action.meta.id));
    case TEMPLATE_CATEGORY_FETCH_TEMPLATES_START:
      return state.setIn([FETCH_TEMPLATES, action.meta.id], true);
    case TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_FULFILLED:
    case TEMPLATE_CATEGORY_FETCH_TEMPLATES_API_REJECTED:
      return state.set(FETCH_TEMPLATES, state[FETCH_TEMPLATES].without(action.meta.id));
    default:
      return state;
  }
};

export const selectors = {
  getCategoriesInUpdateProgressMap: state => state[UPDATE],
  getCategoriesInDeleteProgressMap: state => state[DELETE],
  getCategoriesInFetchTemplatesProgressMap: state => state[FETCH_TEMPLATES]
};
